<template>
  <info-section-card>
    <template v-slot:header>{{L10n('parts')}}</template>
    <div
      class="info-section__content-item"
      v-for="item in listRFQ1"
      :key="item.fieldName">
      <div class="d-flex align-items-center mb-2">
        <div>
          <span class="title">{{item.partNumber}}  </span>
          <span>{{item.partDescription}}</span>
        </div>
        <div class="d-flex" style="margin-left: auto">
          <button
            v-if="isVisibleAddToQuote && isAddToQuote"
            type="button"
            class="btn btn-size-xs ml-1"
            :class="checkRFQ1InRFQ3(item) ? 'btn-red': ''"
            :disabled="isDisabledAddToQuote"
            @click="handleAddToRFQ3(item)"
          >
            {{L10n('add-to-quote')}}
          </button>
          <button
            v-if="isSendQuote && !checkRFQ1InRFQ3(item)"
            type="button"
            class="btn btn-size-xs ml-1"
            @click="handleSend(item)"
          >
            {{L10n('send-quote-no-stock-to-customer-email')}}
          </button>
          <button
            v-if="isSendQuote && checkRFQ1InRFQ3(item)"
            type="button"
            class="btn btn-size-xs ml-1"
            @click="handleSendFollowUp(item)"
          >
            {{L10n('send-quote-followup-to-customer-email')}}
          </button>
        </div>
      </div>
    </div>
    <ui-dialog
      :title="L10n('confirm')"
      :isVisible="isVisibleConfirm"
      @close="handleCloseConfirm"
    >
      {{L10n('are-you-sure')}}
      <template v-slot:footer>
        <div class="activity-po-wo-wrap__footer">
          <button class="btn btn-border grey btn-size-s btn-mobile-full" @click="handleCloseConfirm">
            {{L10n('close')}}
          </button>
          <button class="ml-sm-3 btn btn-border blue btn-size-s btn-mobile-full" @click="handleConfirm">
            {{L10n('confirm')}}
          </button>
        </div>
      </template>
    </ui-dialog>
</info-section-card>
</template>

<script>
export default {
  name: 'InfoSectionParts',
  components: {
    'info-section-card': () => import(/* webpackChunkName: 'InfoSection' */ '@/components/InfoSection/Card.vue'),
    'ui-dialog': () => import(/* webpackChunkName: 'Shared' */ '@/components/Dialogs/Dialog')
  },
  props: {
    listRFQ1: { type: Array, required: true },
    isAddToQuote: { type: Boolean, default: true },
    isDisabledAddToQuote: { type: Boolean, default: false },
    isSendQuote: { type: Boolean, default: true },
    mapListRFQ3: { required: true }
  },
  computed: {
    isVisibleAddToQuote () {
      return this.permission(this.permissions, 'isAllowToViewQuickRFQByParts')
    }
  },
  data () {
    return {
      isVisibleConfirm: false,
      confirmItem: null
    }
  },
  methods: {
    handleCloseConfirm () {
      this.confirmItem = null
      this.isVisibleConfirm = false
    },
    handleConfirm () {
      this.$emit('onAddToRFQ3', { ...this.confirmItem })
      this.confirmItem = null
      this.isVisibleConfirm = false
    },
    handleAddToRFQ3 (item) {
      if (this.checkRFQ1InRFQ3(item)) {
        this.confirmItem = item
        this.isVisibleConfirm = true
        return
      }
      this.$emit('onAddToRFQ3', { ...item })
    },
    handleSend (item) {
      this.$emit('onSend', { ...item })
    },
    handleSendFollowUp (item) {
      const key = item.rfqid + '__' + item.partID
      this.$emit('onSendFollowup', { ...this.mapListRFQ3[key] })
    },
    checkRFQ1InRFQ3 (rfq1) {
      return !!this.mapListRFQ3[rfq1.rfqid + '__' + rfq1.partID]
    }
  }
}
</script>
